// Kệ khác vị trí hiện tại của lô thì backend luôn tạo lô mới; chỉ khi chọn đúng
// kệ cũ mới theo ô tick.
export function sendsNewLot(
    positionId: string,
    currentPositionId: string | undefined,
    tick: boolean,
): boolean {
    return positionId !== currentPositionId || tick
}
